import { useNavigate } from 'react-router-dom'
import { Box, Button, VStack } from '@chakra-ui/react'
import CollapsibleNavMenu from './components/CollapsibleNavMenu'
import NavItem from './NavItem'
import { useAuth } from './context/AuthContext'

const Navigation = () => {
  const { isAuthenticated, logout, user } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await logout()
    navigate('/')
  }

  return (
    <Box
      as="nav"
      w="64"
      bg="gray.800"
      p={4}
      borderRight="1px"
      borderColor="whiteAlpha.200"
    >
      <VStack gap={2} alignItems="stretch">
        {isAuthenticated && user?.role && ['admin', 'super_admin'].includes(user.role) && (
          <>
            <NavItem to="/dashboard">Home</NavItem>
            <NavItem to="/admin">Administration</NavItem>
            <NavItem to="/capriole">Capriole</NavItem>
            <NavItem to="/brainstorm">Brainstorm Tasks</NavItem>
            <CollapsibleNavMenu label="CryptoQuant">
              <NavItem to="/cryptoquant-sentiments">Sentiments</NavItem>
              <NavItem to="/cryptoquant-detailed-sentiments">Detailed Sentiments</NavItem>
            </CollapsibleNavMenu>
          </>
        )}
        {isAuthenticated && user?.role && ['admin', 'super_admin'].includes(user.role) && (
          <>
            <CollapsibleNavMenu label="In progress">
              <NavItem to="/education">Education</NavItem>
              <NavItem to="/fun">Fun</NavItem>
              <NavItem to="/portfolio-management">Portfolio Management</NavItem>
              <NavItem to="/tangental-assets">Tangental Assets</NavItem>
              <NavItem to="/incremental-allocations">Incremental Allocations</NavItem>
            </CollapsibleNavMenu>
            <CollapsibleNavMenu label="TODO">
              <NavItem to="/options-heat-map">Options Heat Map</NavItem>
              <NavItem to="/tpi">TPI</NavItem>
            </CollapsibleNavMenu>
          </>
        )}
        <CollapsibleNavMenu label="Symbols">
          <NavItem to="/bitcoin">₿itcoin</NavItem>
          <NavItem to="/strategy">Strategy</NavItem>
          <NavItem to="/msty">MSTY</NavItem>
          <NavItem to="/ethereum">Ethereum</NavItem>
        </CollapsibleNavMenu>
        {isAuthenticated ? (
          <VStack gap={2} pt={4} borderTop="1px" borderColor="whiteAlpha.200">
            <Box color="whiteAlpha.700" fontSize="sm">
              {user?.email}
            </Box>
            <Button
              colorScheme="red"
              size="sm"
              width="full"
              onClick={handleLogout}
            >
              Logout
            </Button>
          </VStack>
        ) : (
          <NavItem to="/login">Login</NavItem>
        )}
      </VStack>
    </Box>
  )
}

export default Navigation
